import initState1 from '../../softdata.json';
const initState = {
    ...initState1[0].consultation
}
const consultationReducer = (state = initState, action) => {
    return state;
}
export default consultationReducer
